import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";

const KonobarHome = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/admin-login");
  };

  return (
    <div className="konobar-home">
      {" "}
      {/* Koristimo iste klase za dizajn */}
      <div className="admin-header">
        <h3>Konobari</h3>
        <button onClick={handleLogout} className="logout-btn-minimal">
          Odjava
        </button>
      </div>
      <div className="admin-grid">
        {/* Gumb za Šank */}
        <div className="admin-card" onClick={() => navigate("/sank-panel")}>
          <i className="fi fi-rs-drink-alt" style={{ color: "#FFD700" }}></i>
          <span>Šank</span>
          <i className="fi fi-rs-angle-small-right"></i>
        </div>
        <div className="admin-card" onClick={() => navigate("/inventory-edit")}>
          <i
            className="fi fi-rs-settings-sliders"
            style={{ color: "#00ff88" }}
          ></i>
          <span>Uredi Listu Proizvoda</span>
          <i className="fi fi-rs-angle-small-right"></i>
        </div>
        <div
          className="admin-card"
          onClick={() => navigate("/inventory-stats")}
        >
          <i className="fi fi-rs-stats" style={{ color: "#00ff88" }}></i>
          <span>Status proizvoda</span>
          <i className="fi fi-rs-angle-small-right"></i>
        </div>
      </div>
    </div>
  );
};

export default KonobarHome;
